import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import DynamicServiceOrderLoader from './_load/DynamicServiceOrderLoader'
import EditDynamicServiceOrders from './EditDynamicServiceOrders'

const EditDynamicServiceOrdersModal = props => {
  return (
    <ControlledModal width="42rem" disableClickOutside {...props}>
      <PermissionChecker any={['createDynamicServiceOrder', 'editDynamicServiceOrder']}>
        <ModalHeader />
        <DynamicServiceOrderLoader>
          <EditDynamicServiceOrders />
        </DynamicServiceOrderLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditDynamicServiceOrdersModal
